import { QueryClient } from '@tanstack/react-query';

// Конфігурація React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 хвилин
      retry: (failureCount, error: any) => {
        // Не повторюємо запити при помилках аутентифікації
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

// Query keys для кешування
export const QUERY_KEYS = {
  // Аутентифікація
  CURRENT_USER: ['auth', 'currentUser'] as const,

  // Користувачі
  USERS: ['users'] as const,
  USER: (id: string) => ['users', id] as const,

  // Додавайте інші ключі за необхідності
} as const;